export { THEME } from './themes'
export { LANG_KEY } from './LANG_KEY'
export { ROUTE_PATH } from './routes'
export { COOKIE_KEY } from './main'
export { COMPONENT_TYPES_ENUM } from './component-types'

export { JOURNAL_TYPES, JOURNAL_YEAR, JOURNAL_TYPES_API, JOURNAL_QUERY_PARAMS } from './journal'
export { PLANS_TYPES } from './plans'

export {
  FORM_SECTION_INNER_TYPE,
  FORM_FORM_TYPE,
  PLANS_API,
  FORM_SECTION_TYPES,
  JOURNAL_API,
  FILE_FORM_API,
} from './form'

export { RUP_BASE_TYPES } from './rup'


export const QUERY_PARAMS = {
  type: 'type',
  subtitle: 'subtitle',
  subInner: 'subInner'
}


export const SCHEDULE_TYPES = [
  {
    id: 1,
    name: "Работа с педагогами"
  },
  {
    id: 2,
    name: "Работа с родителями"
  },
  {
    id: 3,
    name: "Работа со студентами"
  }
]

export const DATE_FORMAT ={
  FULL:"YYYY-MM-DD HH:mm:ss",
  FRONT_TIME:"DD.MM.YYYY HH:mm:00",
  BACKEND_TIME:"YYYY-MM-DD HH:mm:00",
  FRONT:"DD.MM.YYYY",
  BACKEND:"YYYY-MM-DD"
}
